<template>
  <input type="text" v-mask="/\d{0,100}/">
</template>

<script>
  export default {
    name: "num-input",
  }
</script>

<style scoped>

</style>
